export default __webpack_public_path__ + "img/italic.cea5bb1a.svg";